<template>
  <div>
    <CRUDCriteria :showReset='true' :showSearch='false' :showAdditionalActions='true'>
      <template v-slot:criteriaRows>
        <div class='mt-0 ml-6 mr-6 mb-10 pa-0'>
          <v-row class='ma-n4'>
            <v-col cols='3' class='pt-0 pb-0'>
              <CommonDropDowns :isItTaxYear=true @change="dataFromCommonDropDowns"
              :criteriaState="criteriaState"/>
            </v-col>
            <v-col cols='3' class='pt-0 pb-0'>
              <v-text-field class='input-text-size'
              @change="searchByCriteria"
              v-model.number="criteriaState.taxId">
                <template v-slot:label>
                  <label>Tax ID</label>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols='3' class='pt-0 pb-0'>
              <v-text-field class='input-text-size'
              @change="searchByCriteria" v-model.number="criteriaState.warrantNumber">
                <template v-slot:label>
                  <label>Warrant Number</label>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols='3' class='pt-0 pb-0'>
              <v-text-field class='input-text-size ptw-from-warrant-number'
              @change="searchByCriteria" v-model.number="criteriaState.fromWarrantNumber">
                <template v-slot:label>
                  <label>From Warrant #</label>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols='3' class='pt-0 pb-0'>
              <v-text-field class='input-text-size ptw-to-warrant-number'
              @change="searchByCriteria" v-model.number="criteriaState.toWarrantNumber">
                <template v-slot:label>
                  <label>To Warrant #</label>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols='3' class='pt-0 pb-0'>
              <v-text-field class='input-text-size'
              v-uppercase=globalSettingItem.conEverythingToCaps
              @change="searchByCriteria" v-model="criteriaState.ownerName">
                <template v-slot:label>
                  <label>Name</label>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols='3' class='pt-2'>
              <v-btn color="primary" dense small @click="handleDialog">
                          Add Personal Tax Warrants
                        </v-btn>
            </v-col>
            <v-col cols='2' class='pt-2 pb-0 mt-n6'>
              <ClarionDateControl class='input-text-size'
              :isIsoDate='true' v-model='criteriaState.fromDate'
               :isRequired="false" :isToggle="false"
                label='From Date' />
            </v-col>
            <v-col cols='2' class='pt-2 pb-0 mt-n6'>
              <ClarionDateControl class='input-text-size'
              :isIsoDate='true' v-model='criteriaState.toDate'
               :isRequired="false" :isToggle="false"
                label='To Date' />
            </v-col>
            <v-col cols='2' class='pt-2 pb-0 mt-n6'>
              <ClarionDateControl class='input-text-size'
              :isIsoDate='true' v-model='criteriaState.penaltyDate'
              @blurred="searchByCriteria"
              :penalty-change-day="Number(taxSettingItem.penaltyDate) || null"
               :isRequired="false" :isToggle="false"
                label='Penalty Date' />
            </v-col>
            <v-col cols='3' class='pt-2 pb-0 mt-n6'>
              <v-select class='input-text-size ptw-not-printed-select'
              label='Not yet printed'
              :items='notPrintedOptions'
              item-text='text'
              item-value='value'
              clearable
              @change="searchByCriteria" v-model="criteriaState.notPrinted" />
            </v-col>
            <v-col cols='3' class="pt-2 pb-0 mt-n6">
              <v-checkbox class="input-text-size"
              @change="searchByCriteria" v-model="criteriaState.isActive"
              :label="`Show Active Warrant Only`"></v-checkbox>
            </v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:additionalActions>
        <v-col cols='2' class='pt-2'>
        </v-col>
      </template>
    </CRUDCriteria>
    <TaxWarrantCreateDialog  :baseCrudKey="baseCrudKey" />
  </div>
</template>
<script>
import {
  mapGetters, mapState,
} from 'vuex';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import CRUDCriteria from '../../common/base/crud-2.0/CRUDCriteria.vue';
import TaxWarrantCreateDialog from '../TaxInquiry/Common/TaxWarrantsCreateDialog.vue';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';
import '../../../assets/style.css';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';
import { TaxWarrantsCriteriaMixin } from './utils/taxWarrants.mixin';
import { createNewWarrantItem } from './utils/taxWarrants.util';

export default {
  name: 'TaxWarrantsCriteria',
  mixins: [GlobalToCaps, TaxWarrantsCriteriaMixin],
  data() {
    return {
      dialogCrudKey: 'personalTaxWarrantCreate',
      // The warrant form and the letter are missed independently, so each is its own
      // answer rather than one "printed?" flag covering both.
      notPrintedOptions: [
        { text: 'Warrant form not printed', value: 'form' },
        { text: 'Letter not printed', value: 'letter' },
      ],
    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'personalTaxWarrants',
    },
  },
  components: {
    ClarionDateControl,
    CRUDCriteria,
    TaxWarrantCreateDialog,
    CommonDropDowns,
  },

  computed: {
    ...mapGetters('base/crud', ['criteria']),
    ...mapState({
      nextWarrantNumber: (state) => state.tax.taxWarrants.nextWarrantNumber,
      nextWarrantSystemID: (state) => state.tax.taxWarrants.nextWarrantSystemID,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem || {},
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
  },

  methods: {
    // Custom dialog handler for this component
    async handleDialog() {
      await this.loadLastWarrantNo();

      const newItem = createNewWarrantItem({
        taxYear: this.criteriaState.taxYear,
        taxId: this.criteriaState.taxId,
        // The number's prefix follows the county's current tax year, NOT the tax year
        // being searched on - searching 2021 still issues a 25nnnnn warrant.
        warrantTaxYear: this.currentWarrantTaxYear,
        nextWarrantNumber: this.nextWarrantNumber,
        nextWarrantSystemID: this.nextWarrantSystemID,
        taxSettingItem: this.taxSettingItem,
      });

      this.setItem([this.dialogCrudKey, newItem]);
      await this.setIsVisible([this.dialogCrudKey, true]);
    },
  },
};
</script>

<style scoped>
.label {
  font-size: 0.85rem;
}
</style>
